import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { formatNumber } from 'lib/pluralise';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import {
  NAVIGATE_MODAL,
  doSetupBillingAdminDeleteProductUnits,
} from 'store/actions';
import {
  selectBillingProduct,
  selectBillingProductUnits,
} from 'store/remote/selectors';

type Props = {
  productId: string;
};

export const BillingProductUnitCard: React.FC<Props> = ({ productId }) => {
  const dispatch = useDispatch();

  const product = useSelector((state) =>
    selectBillingProduct(state, productId),
  );

  const productUnits = useSelector((state) =>
    selectBillingProductUnits(state, productId),
  );

  if (!product) {
    return null;
  }

  return (
    <CardRow
      label={product.name}
      value={`${productUnits?.units || 0}`}
      onPress={() =>
        dispatch(
          NAVIGATE_MODAL({
            screen: ModalScreens.SettingsBillingProductUnits,
            params: { productId: product.id },
          }),
        )
      }
      menuOptions={[
        {
          text: 'Delete Product Units',
          icon: ICONS.TrashCanLight,
          destructive: true,
          onPress: () =>
            dispatch(doSetupBillingAdminDeleteProductUnits({ productId })),
        },
      ]}
    >
      <Txt
        style={{
          textAlign: 'right',
          color: theme.colors.fieldValueText,
        }}
      >
        {formatNumber(productUnits?.units || 0)}
      </Txt>
    </CardRow>
  );
};
